// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center[data-v-5475713b]{text-align:center}.right[data-v-5475713b]{text-align:right}.justify[data-v-5475713b]{text-align:justify}.header[data-v-5475713b]{font-size:32px}.secondary[data-v-5475713b]{color:#5e6163;font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
